
export class Regle {
    map;
    balise;
    clickLong;
    clickMesure;
    pointMesure;
    mouvePoint;
    flightPath;
    fixePoint;
    isActive;
    constructor(map) {
        this.map = map;
        const longueurLink = document.createElement("a");
        longueurLink.textContent = "Règle";
        longueurLink.className = 'w-auto inactive';
        longueurLink.href = "#";
        longueurLink.id = "Longueur";
        longueurLink.title = trans.get('common.add');
        const that = this;
        longueurLink.addEventListener('click', function() {
            that.onClickMenu.bind(that);
            that.onClickMenu();
        });
        this.fixePoint = [];
        this.pointMesure = [];
        this.balise = longueurLink;
    }
    getItemMenu() {
        return this.balise;
    }
    onClickMenu(){
        // nous etions en mode "actif" 
        if (this.isActive) {
            // on desactive
            this.map.setOptions({ draggableCursor: 'grab' });
            this.balise.classList.remove('active');
            this.balise.classList.add('inactive');
            google.maps.event.clearListeners(this.map, 'click');
            this.clickMesure = 0;
            
            if (this.pointMesure.length > 0) {
                // we remove last point
                this.pointMesure.pop();
                this.mouvePoint.setMap(null);
                this.mouvePoint.setPosition(null);
                this.mouvePoint=null;
                this.flightPath.setPath(this.pointMesure);
            }

            this.isActive = false;
        } else {
            this.clickMesure = 0;
            // on réinitialise les champs et on active le mode
            if(this.mouvePoint) {
                this.mouvePoint.setMap(null);
                this.mouvePoint.setPosition(null);
                this.mouvePoint = null;
            }
            this.fixePoint.forEach((element) => {
                element.setMap(null);
                element.setPosition(null);
                element = null;
            });
            this.fixePoint = [];
            if(this.flightPath) {
                this.flightPath.setPath(this.pointMesure);
                this.flightPath.setMap(null);
                this.flightPath = null;
            }
            this.pointMesure = [];

            this.balise.classList.remove('inactive');
            this.balise.classList.add('active');
            this.map.setOptions({ draggableCursor: 'crosshair' });
            // on supprime 
            google.maps.event.clearListeners(this.map, 'click');
            // on ajoute les event listeners
            const that = this;
            google.maps.event.addListener(this.map, "click", function(e) {
                that.handleClickOnMap.bind(that);
                that.handleClickOnMap(e);
            });
            google.maps.event.addListener(this.map, "mousemove", function(e) {
                that.handleMouseMoveOnMap.bind(that);
                that.handleMouseMoveOnMap(e);
            });
            this.isActive = true;
        }
    }
    handleClickOnMap(evt) {
        this.clickMesure++;
        var path = this.pointMesure;
        if (this.clickMesure == 1) {
            this.flightPath = new google.maps.Polyline({
                path: path,
                map: null,
                geodesic: true,
                strokeColor: "#FF0000",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                clickable: false,
            });

            this.mouvePoint = new google.maps.Marker({
                map: null,
                icon: {
                    url: '/image/mesure.png',
                },
            });

            this.flightPath.setMap(this.map);
            this.mouvePoint.setMap(this.map);
        }

        this.pointMesure.push({
            'lat': evt.latLng.lat(),
            'lng': evt.latLng.lng(),
        });
        if (this.clickMesure > 1) {
            var dist = Math.round(turf.distance(
                [this.pointMesure[this.clickMesure - 2].lng, this.pointMesure[this.clickMesure - 2].lat],
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat]
            ) * 1000);
            var temp = turf.points([
                [this.pointMesure[this.clickMesure - 2].lng, this.pointMesure[this.clickMesure - 2].lat],
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat]
            ]);
            var center = turf.center(temp).geometry.coordinates;

            this.fixePoint.push(new google.maps.Marker({
                map: this.map,
                icon: {
                    url: '/image/mesure.png',
                },
            }));
            this.fixePoint[this.fixePoint.length - 1].setPosition({
                'lat': center[1] + 0.00001,
                'lng': center[0],
            });
            this.fixePoint[this.fixePoint.length - 1].setLabel({
                text: dist + " m",
                color: "white",
            });
        }
    }
    handleMouseMoveOnMap(evt) {        
        if (this.pointMesure.length > 0) {
            this.pointMesure[this.clickMesure] = {
                'lat': evt.latLng.lat(),
                'lng': evt.latLng.lng(),
            };

            var dist = Math.round(turf.distance(
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat],
                [this.pointMesure[this.clickMesure].lng, this.pointMesure[this.clickMesure].lat]
            ) * 1000);

            var temp = turf.points([
                [this.pointMesure[this.clickMesure - 1].lng, this.pointMesure[this.clickMesure - 1].lat],
                [this.pointMesure[this.clickMesure].lng, this.pointMesure[this.clickMesure].lat]
            ]);
            var center = turf.center(temp).geometry.coordinates;

            this.mouvePoint.setPosition({
                'lat': center[1] + 0.00001,
                'lng': center[0],
            });
            this.mouvePoint.setLabel({
                text: dist + " m",
                color: "white",
            });

            this.flightPath.setPath(this.pointMesure);
        }
    }
}
export default Regle;